import { createAction, handleActions } from 'redux-actions';
import http from '../../utility/http';
import {
  API_RBAC_AUTH_PERMISSIONS,
  API_RBAC_AUTH_DIRECT_REPORTS,
  API_RBAC_AUTH_INDIRECT_REPORTS,
  API_RBAC_AUTH_SCOPED_USERS,
} from '../../constants/apiRoutes';

// ------------------------------------
// Constants
// ------------------------------------

const SET_ACCESS_CONTROL = 'SET_ACCESS_CONTROL';
const SET_AUTH_REPORTERS = 'SET_AUTH_REPORTERS';
const SET_AUTH_SCOPED_USERS = 'SET_AUTH_SCOPED_USERS';

const initialState = {
  permissions: [],
  directReports: [],
  indirectReports: [],
  customEmployeesScope: [],
};

// ------------------------------------
// Actions
// ------------------------------------

const setAccessControl = createAction(SET_ACCESS_CONTROL);
const setAuthReporters = createAction(SET_AUTH_REPORTERS);
const setAuthScopedUsers = createAction(SET_AUTH_SCOPED_USERS);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_ACCESS_CONTROL]: (state, { payload }) => {
    return { ...payload };
  },
  [SET_AUTH_REPORTERS]: (state, { payload }) => {
    return {
      ...state,
      directReports: payload.directReports,
      indirectReports: payload.indirectReports,
    };
  },
  [SET_AUTH_SCOPED_USERS]: (state, { payload }) => {
    return {
      ...state,
      customEmployeesScope: payload.customEmployeesScope,
    };
  },
};

export const getAuthPermissions = dispatch =>
  Promise.all([
    http.get(API_RBAC_AUTH_PERMISSIONS),
    http.get(API_RBAC_AUTH_DIRECT_REPORTS),
    http.get(API_RBAC_AUTH_INDIRECT_REPORTS),
    http.get(API_RBAC_AUTH_SCOPED_USERS),
  ]).then(
    ([permissions, directReports, indirectReports, customEmployeesScope]) => {
      return dispatch(
        setAccessControl({
          permissions: permissions.data,
          directReports: directReports?.data ?? [],
          indirectReports: indirectReports?.data ?? [],
          customEmployeesScope: customEmployeesScope?.data ?? [],
        })
      );
    }
  );

export const getAuthReporters = dispatch =>
  Promise.all([
    http.get(API_RBAC_AUTH_DIRECT_REPORTS),
    http.get(API_RBAC_AUTH_INDIRECT_REPORTS),
  ]).then(([directReports, indirectReports]) => {
    const reporters = {
      directReports: directReports?.data,
      indirectReports: indirectReports?.data,
    };
    dispatch(setAuthReporters(reporters));

    return reporters;
  });

export const getAuthScopedUsers = dispatch =>
  http.get(API_RBAC_AUTH_SCOPED_USERS).then(({ data }) => {
    const customEmployeesScope = data;
    dispatch(setAuthScopedUsers({ customEmployeesScope }));

    return customEmployeesScope;
  });

export default handleActions(reducers, initialState);
